module.exports = __webpack_public_path__ + "static/media/reserva.51bd4c1e.png";